import React, {Component} from 'react';

class HistoryTransactionComponent extends Component {

    listInfoOrder = () => {
        return (
            this.props.payment.order_info.map( (order_info, key) => (
                <div key={key}>
                    { order_info.value }
                </div>
            ))
        )
    }

    loadStatus = () => {
        if ( this.props.payment.status === 'Pending' ) {
            return (
                <span className="text-danger">Chưa thanh toán</span>
            )
        }
        else if ( this.props.payment.status === 'Active' || this.props.payment.status === 'Waiting'  ) {
            return (
                <span className="text-success">Đã thanh toán</span>
            )
        }
        else {
            return (
                <span className="text-default">Hủy</span>
            )
        }
    }


    render() {
        return (
            <tr>
                <td>{ this.props.payment.ma_gd }</td>
                <td>
                    { this.props.payment.text_type_order }
                </td>
                <td>
                    { this.listInfoOrder() }
                </td>
                <td>{ this.props.payment.text_total }</td>
                <td>{ this.props.payment.text_date_create }</td>
                <td>{ this.props.payment.text_amount_before }</td>
                <td>{ this.props.payment.text_amount_after }</td>
                <td>{ this.loadStatus() }</td>
            </tr>
        );
    }
}

export default HistoryTransactionComponent;